<template>
  <div>
    <div class="mt-4">
      <AlertBannerRecords path="/vehicles" :message="vehiclesMessage" />
      <AlertBannerRecords path="/maestro/fees" :message="scheduleMessage" />
    </div>
    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder="Pesquisar por Placa ou Renavam"
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>
    
      <button
        class="col-md-2 ml-2 btn-sm btn-outline"
        :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter"
      >
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>
    
      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query" @clearBadge="find()"
          @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges"
          :filters="badgesFilters"
        />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-4">
          <label>Empresas</label>
          <Select2 :options="filterCnpjs" v-model="query.cnpj"/>
        </div>

        <div class="col-md-4">
          <label>Serviço</label>
          <Select2 :options="filterConsultedAuthority" v-model="query.consultedAuthority"/>
        </div>

        <div class="col-md-4">
          <label>Status da Taxa</label>
          <Select2 :options="filterStatus" v-model="query.status"/>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4">
          <label>Status do Veículo</label>
          <select v-model="query.entityStatusId" class="browser-default custom-select">
            <option
              v-for="opt in (filterEntityStatusId ? filterEntityStatusId.table : [])"
              :key="opt.value" :value="opt.value"
            >{{ opt.label }}</option>
          </select>
        </div>

        <div class="col-md-4">
          <label>Tipo de taxa</label>
          <Select2 :options="filterKind" v-model="query.kind"/>
        </div>

        <div class="col-md-4">
          <label>Final da placa</label>
          <Select2 :options="filterEndNum" v-model="query.end_num"/>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4">
          <label for="type-period">Tipo do período</label>
          <select v-model="query.periodType" id="type-period" class="browser-default custom-select">
            <option value="updated_at">Data de atualização</option>
            <option value="occurred_at">Data da ocorrência</option>
            <option value="created_at">Data de criação</option>
            <option value="expired_at">Data de vencimento</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>
        
        <div class="col-md-4">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      </div>

    </template>
    <hr>

    <!-- Buttons -->
    <div class="row mt-2">
      <div class="col-md-12">
        <button
            v-if="$withPolicy('cm-taxas', 'consult')"
            class="btn btn-primary mt-1 mr-1"
            @click="showModal = true"
          >
          Consulta avulsa
        </button>

        <Dropdown
            v-if="$withPolicy('cm-taxas', 'download_xlsx')"
            title-dropdown="Exportar"
            class="btn btn-primary mt-1 mr-1"
            :enable="someFeeSelected"
        >
          <ul class="mb-1 mt-1">
            <li class="dropdown-item" @click="toXLSX()">
              Taxas
            </li>
          </ul>
        </Dropdown>

        <template v-if="$withPolicy('cm-taxas', 'consult_history')">
          <router-link
            tag="button"
            to="/cm-taxas/consultas"
            class="btn btn-primary mt-1 mr-1"
          >
            Histórico de consultas
          </router-link>
        </template>

        <template v-if="getUser.brobotStaff">
          <router-link
            tag="button"
            to="/cm-taxas/configuracoes"
            class="btn btn-primary mt-1 mr-1"
          >
            Configurações
          </router-link>
        </template>

        <button
          class="btn btn-outline mt-1 float-right relative"
          @click="showSelectColumns = true"
        >
          Mostrar colunas
        </button>

      </div>
    </div>

    <!-- Info -->
    <div class="row mt-4">
      <div class="col-md-12">
        <small>
          {{ infoTotalModels }}
          <template v-if="meta.lastConsult">
            Última consulta realizada em: {{ meta.lastConsult | datetime }}
          </template>
        </small>

        <button
            v-if="fees.length > 0"
            class="btn btn-outline ml-3 mb-1"
            @click="changeCheck({checkAll: !checkAll, sources: fees})"
            :class="{ 'btn-outline-active': checkAll }"
        >
          {{ !checkAll ? 'Selecionar todas' : 'Desmarcar todas' }} ({{ meta.totalCount || 'Calculando' }})
        </button>

        <div class="float-right" style="display: inline-flex;align-items: center;">
          <small class="mr-2" style="white-space: nowrap">Ordenar por:</small>
          <select v-model="order" @change="updateOrder(order)" class="browser-default custom-select">
            <option :value="['updated_at', 'desc']">Data de atualização</option>
            <option :value="['created_at', 'desc']">Data de criação</option>
            <option :value="['expired_at', 'desc']">Data de vencimento</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-md-12 mt-2">
        <Table
          :fees="fees"
          :columns="selectedColumns"
          :entity-status-names="entityStatusNames"
          @changeCheckAllRow="changeCheckAllRow"
          @changeCheckRow="changeCheckRow"
          @fetchFees="asyncTemplateSelect({ pagination: true })"
          :check-all-row="checkAllRow"
        />

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>

      </div>
    </div>

    <VehicleRequestModal v-model="showModal" appName="cm-taxas" width="lg"/>

    <Modal v-model="showSelectColumns" width="lg">
      <div slot="header">
        Mostrar colunas
      </div>

      <div>
        <p>Selecione as colunas que deseja visualizar na tabela do CaçaMultas:</p>
      </div>

      <table class="columnsSelector table table-borderless table-border table-align">
        <thead>
          <tr>
            <th></th>
            <th>Nome da Coluna</th>
            <th>Descrição</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="column in sortedTableColumns" :key="column.key">
            <td>
              <input
                  type="checkbox"
                  :id="column.key"
                  v-model="column.checked"
                  @change="updateColumnsInLocalStorage"
                  class="cursor-pointer"
              />
            </td>
            <td>{{ column.label }}</td>
            <td>{{ column.description }}</td>
          </tr>
        </tbody>
      </table>
    </Modal>
  </div>
</template>

<script>
  import AlertBannerRecords from '@/components/shares/AlertBannerRecords'
  import BadgeFilters from '@/components/shares/BadgeFilters'
  import CheckedModels from '@/mixins/CheckedModels'
  import Dropdown from '@/components/shares/specialTag/Dropdown'

  import Formatter from '@/models/Formatter'
  import GetAccount from '@/mixins/GetAccount.vue'
  import GetUser from '@/mixins/GetUser.vue'
  import Modal from '../shares/specialTag/Modal'

  import ModelMapper from '@/mixins/ModelMapper'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import Select2 from '@/components/shares/Select2'

  import VehicleRequestModal from '../vehicles/VehicleRequestModal'
  import Table from '@/components/cm-taxas/Table'

  import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
  import { Filter } from '@/models/filter'
  import { IssuingAuthority } from '@/models/IssuingAuthority'
  import Sorter from '@/models/Sorter'
  import { VEHICLE_STATUS, VEHICLE_STATUS_OPTIONS, VEHICLE_STATUS_FILTER_TABLE } from '@/utils/vehicleStatus'

  const formatterInstallment = value => ({
    '1': 'Única',
    '1.2': 'Única (opção 2)',
  }[value] || value)

  const translateStatus = value => {
    return {
      expired: 'Vencido',
      opened: 'Em aberto',
      undefined: '',
      paid: 'Pago',
    }[value]
  }

  const keyTemplateColumns = 'feeTemplateColumns'
  const keyOrderby = 'feeOrderBy'
  const fiveYearsInMinutes = 60 * 24 * 30 * 12 * 5

  const mapKind = str => {
    return {
      ipva: 'IPVA',
      licenciamento: 'Licenciamento',
      crv: 'CRV',
      registro: 'Registro',
      dpvat: 'DPVAT',
      vistoria: 'Vistoria',
      bombeiro: 'Bombeiro',
      others: 'Outros'
    }[str] || str
  }

  const tableColumns = [
    { key: 'plate', label: 'Placa', checked: true, description: 'Placa do veículo' },
    { key: 'renavam', label: 'Renavam', checked: true, description: 'Número do Renavam (Registro Nacional de Veículos Automotores)' },
    { key: 'cnpj', label: 'CNPJ', checked: true, method: Formatter.cnpj, description: 'Número do CNPJ (Cadastro Nacional da Pessoa Jurídica)' },
    { key: 'status', label: 'Status da Taxa', checked: true, method: translateStatus, description: 'Status da taxa' },
    { key: 'entityStatusId', label: 'Status do Veículo', checked: true, description: 'Status do veículo' },
    { key: 'kind', label: 'Tipo', checked: true, description: 'Tipo de taxa', method: mapKind },
    { key: 'year', label: 'Ano', checked: true, description: 'Ano da taxa' },
    { key: 'installment', label: 'Parcela', checked: true, description: 'Tipo de pagamento', method: formatterInstallment },
    { key: 'valueCents', label: 'Taxa Calculada', checked: true, method: Formatter.centsToPrice, description: 'Valor calculado da taxa' },
    { key: 'paid_amount_cents', label: 'Valor Pago', checked: false, method: Formatter.centsToPrice, description: 'Valor pago (informação retornada pelo órgão consultado, porém nem todos os órgãos retornam esta informação)' },
    { key: 'finalValueCents', label: 'Valor a pagar', checked: true, method: Formatter.centsToPrice, description: 'Valor a pagar', info: true },
    { key: 'consultedAuthority', label: 'Serviço', checked: true, method: IssuingAuthority.label, description: 'Serviço' },
    { key: 'expiredAt', label: 'Data de Vencimento', checked: true, method: Formatter.stringToDate, description: 'Data de vencimento' },
    { key: 'boleto_due_date', label: 'Data de Vencimento do Boleto', checked: true, method: Formatter.stringToDate, description: 'Data de vencimento do boleto retornado na última consulta' },
    { key: 'barcode_digits', label: 'Linha digitável', checked: true, description: 'Linha digitável/código de barras do último boleto baixado' },
    { key: 'createdAt', label: 'Criado em', checked: true, method: Formatter.stringToDatetime, description: 'Criado em' },
    { key: 'updatedAt', label: 'Atualizado em', checked: true, method: Formatter.stringToDatetime, description: 'Atualizado em' },
  ]

  export default {
    components: {
      AlertBannerRecords,
      BadgeFilters,
      ChevronDownIcon,
      Dropdown,
      VehicleRequestModal,
      Modal,
      Pagination,
      SearchIcon,
      Select2,
      Table
    },
    computed: {
      badgesFilters() {
        return [
          this.filterIssuingAuthority,
          this.filterCnpjs,
          this.filterStatus,
          this.filterEndDate,
          this.filterStartDate,
          this.filterConsultedAuthority,
          this.filterKind,
          this.filterEndNum,
          this.filterEntityStatusId
        ]
      },
      fees() {
        return this.getModels || []
      },
      selectedColumns() {
        return this.tableColumns.filter(column => column.checked)
      },
      sortedTableColumns() {
        return Sorter.sortBy(this.tableColumns, 'label')
      },
      someFeeSelected() {
        return this.checkAll || this.fees.some(ticket => ticket.checked)
      }
    },
    created() {
      const order = this.$ls.get(keyOrderby)
      this.order = order || ['updated_at', 'desc']
      this.methods = ['vehicle']
      this.$set(this.query, 'periodType', 'updated_at')
      this.$set(this.query, 'entityStatusId', String(VEHICLE_STATUS.ENABLED))
      this.defaultModelSetting.updateQueryURL = true

      this.asyncTemplateSelect({
        byURL: true,
        pagination: true,
        finish: () => this.loadFilters()
      })

      this.loadEntityStatus()
      this.initializersTableColumns()
    },
    data: () => ({
      filterCnpjs: null,
      filterConsultedAuthority: null,
      filterIssuingAuthority: null,
      filterKind: null,
      filterEntityStatusId: null,
      entityStatusNames: {},
      filterEndDate: new Filter({
        key: 'endDate',
        label: 'Data final',
        type: 'date'
      }),
      filterStartDate: new Filter({
        key: 'startDate',
        label: 'Data inicial',
        type: 'date'
      }),
      filterStatus: new Filter({
        key: 'status',
        label: 'Status da Taxa',
        table: [
          ['Cancelado', 'canceled'],
          ['Vencido', 'expired'],
          ['Pago', 'paid'],
          ['Prescrito', 'prescribed'],
          ['Em aberto', 'opened'],
          ['Sem informação', 'undefined']
        ]
      }),
      filterEndNum: new Filter({
        key: 'end_num',
        label: 'Final da placa',
        table: [
          ['0', '0'],
          ['1', '1'],
          ['2', '2'],
          ['3', '3'],
          ['4', '4'],
          ['5', '5'],
          ['6', '6'],
          ['7', '7'],
          ['8', '8'],
          ['9', '9']
        ]
      }),
      modelPathPrefix: 'maestro',
      nameModel: 'Fee',
      showFilter: false,
      showModal: false,
      showSelectColumns: false,
      vehicles: [],
      tableColumns: tableColumns,
      vehiclesMessage: 'Ainda não existem veículos cadastrados no sistema. <a href="/definitions?tab=vehicles">Clique aqui</a> para ir para o cadastro de veículos.',
      scheduleMessage: 'Ainda não existem taxas registradas no sistema. <a href="/cm-taxas/configuracoes">Clique aqui</a> para ir para o agendamento de consultas.',
    }),
    filters: {
      authority(code) {
        return IssuingAuthority.label(code)
      }
    },
    methods: {
      updateOrder(order) {
        this.find()
        this.$ls.set( keyOrderby, order, { minutes: fiveYearsInMinutes })
      },
      changeCheckAllRow(value) {
        this.changeCheck({ checkAllRow: value, sources: this.fees })
      },
      changeCheckRow(){
        this.changeCheck({ sources: this.fees })
      },
      find() {
        this.asyncTemplateSelect()
      },
      async loadFilters() {
        const methods = [
          this.loadCompanies,
          this.loadConsultedAuthorities,
          this.loadKinds
        ]

        for (const method of methods)
          await method()
      },
      loadCompanies() {
        const params = {
        q: {
          type: ['parent', 'subsidiary'],
        },
        per_page: 10000,
        meta: false
      }

        return this.axios.get('/companies', { params })
          .then(response => response.data)
          .then((companies) => this.buildFilterCnpj(companies))
      },
      buildFilterCnpj(companies) {
        const cnpjs = companies.map(company => [
          company.name + ' - ' + Formatter.cnpj(company.cnpj),
          company.cnpj
        ])

        this.filterCnpjs = new Filter({
          key: 'cnpj',
          label: 'CNPJ',
          table: cnpjs
        })
      },
      loadConsultedAuthorities() {
        return this.axios.get('/maestro/fees/fetch_column/consulted_authority')
          .then(response => {
            this.filterConsultedAuthority = new Filter({
              key: 'consultedAuthority',
              label: 'Órgãos consultados',
              table: response.data.map(code => [IssuingAuthority.label(code), code])
            })
          })
      },
      loadKinds() {
        return this.axios.get('/maestro/fees/fetch_column/kind')
          .then(response => {
            this.filterKind = new Filter({
              key: 'kind',
              label: 'Taxa',
              table: response.data.map(str => [mapKind(str), str])
            })
          })
      },
      loadEntityStatus() {
        this.entityStatusNames = VEHICLE_STATUS_OPTIONS.reduce((map, s) => {
          map[s.id] = s.friendlyName
          return map
        }, {})

        this.filterEntityStatusId = new Filter({
          key: 'entityStatusId',
          label: 'Status do Veículo',
          type: 'select',
          table: VEHICLE_STATUS_FILTER_TABLE
        })

        const column = this.tableColumns.find(c => c.key === 'entityStatusId')
        if (column)
          column.description = 'Status do veículo (ativo, inativo ou excluído)'
      },
      initializersTableColumns() {
        const keys = this.$ls.get(keyTemplateColumns)
        if (!keys)
          return

        this.tableColumns.forEach(column => column.checked = keys.includes(column.key))
      },
      updateColumnsInLocalStorage() {
        const selectedKeys = [...new Set(this.tableColumns.filter(e => e.checked).map(e => e.key))]
        this.$ls.set(keyTemplateColumns, selectedKeys, { minutes: fiveYearsInMinutes })
      },
      toXLSX() {
        let params = this.checkAll ?
          this.buildParams() :
          { q: { id: this.fees.filter(c => c.checked).map(c => c.id) } }

        this.openLoad()
        this.axios.get('maestro/fees/report', { params })
          .then(response => {
            if (response.data)
              this.$parse.downloadByLink(response.data)
            else
              this.$notify.add(response.meta.notice)
          })
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeLoad())
      },
    },
    mixins: [ModelMapper, CheckedModels, GetAccount, GetUser],
    name: 'Index',
    watch: {
      fees(newValue, oldValue) {
        if (newValue !== oldValue)
          this.changeCheck({checkAllRow: false})
      }
    }
  }

</script>

<style scoped>

</style>
